// extracted by mini-css-extract-plugin
export default {"container":"guxZVGCDVQaJNmWJ3Dsa","mealInfo":"q1zOuJNNJLlh8ce7tMq6"};